import React from "react"
import Link from "gatsby-link"
import styled from "styled-components"
import Helmet from "react-helmet"
import "../css/Hide.css"
import {
  TINY_SHADOW,
  TINY_BKG,
  ACTIVE_TEXT,
  SECONDARY_TEXT,
  PRIMARY_TEXT
} from "../components/consts/colors.js"

const TermsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 100px auto;
  width: 100%;
  background-color: ${TINY_BKG};

  a {
    color: ${PRIMARY_TEXT};
    transition: all 200ms ease;
  }
  :hover {
    transform: translateY(-3px);
  }
`

const TermsPostPreview = styled.div`
  display: flex;
  position: relative;
  z-index: 3;
  flex-direction: column;
  align-items: flex-start;
  max-width: 750px;
  margin: 50px 0px;
  padding: 50px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0px 4px 10px ${TINY_SHADOW};
  transition: all 400ms ease;
  h3 {
    margin: 25px 0px 5px 0px;
    font-weight: 400;
  }
  h1 {
    margin-bottom: 25px;
  }
  h5 {
    margin: 25px 0px 5px 0px;
  }
  p {
    margin: 5px 0px 5px 0px;
  }
  @media screen and (max-width: 768px) {
    width: 80%;
    margin: 25px 0px;
  }
  @media screen and (max-width: 615px) {
    width: 90%;
    margin: 10px 0px;
  }
`
const TermsPostInfo = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 50px;

  p {
    color ${ACTIVE_TEXT};
  }
`
export default function Terms({ data }) {
  return (
    <TermsWrapper>
      <TermsPostPreview>
        <h1>Terms of Service</h1>
        <p>
          The following terms and conditions (the "Agreement") govern all use of
          the tinymerch.com website (the "Site") and the services available on
          or at the Site (taken together with the Site, the "Service"). The
          Service is owned and operated by TinyMerch Inc. ("TinyMerch"). The
          Service is offered subject to your (the "User") acceptance without
          modification of all of the terms and conditions contained herein and
          all other operating rules, policies and procedures that may be
          published from time to time on the Site by TinyMerch – including,
          without limitation, Shipping, Return Policy, Privacy Policy and
          others. If you do not agree this Agreement, do not use the Site.
          <br />
          <br />
          TinyMerch is a software-as-a-service company for business who wants to
          outsource the storefront and printing/fulfillment integration of
          selling branding merch. TinyMerch sells ("Products") directly to your
          customers ("Customers").
        </p>
        <h3>Access & Membership</h3>
        <p>
          In order to enjoy all the benefits of TinyMerch, the User must
          register and become a member ("Member"). Membership requires that the
          User registers on the Site (including by filling-out all required
          personal information). To complete registration, the User shall
          provide an email address and a password. The User may never use
          another's TinyMerch account without permission from that user. The
          User is solely responsible for the activity that occurs on User’s
          account, and User must keep its account password secure. The User must
          notify TinyMerch immediately of any breach of security or unauthorized
          use of its account. Although TinyMerch will not be liable for the
          User’s losses caused by any unauthorized use of its account, User may
          be liable for the losses of TinyMerch or others due to such
          unauthorized use. <br />
          <br />TinyMerch may change, suspend or discontinue the Services,
          Products, fees, charges, terms at any time, including the availability
          of any feature, or content. TinyMerch may also impose limits on
          certain features and Services or restrict User's access to parts or
          all of the Services without notice or liability. The User certifies to
          TinyMerch that if User is an individual (i.e., not a corporation) the
          User is at least 18 years of age. The User also certifies that it is
          legally permitted to use the Service, and takes full responsibility
          for the selection and use of the Service. This Agreement is void where
          prohibited by law, and the right to access the Service is revoked in
          such jurisdictions.
        </p>
        <h3>Content</h3>
        <h5>Your Content on Our Services</h5>
        <p>
          Content that you post using our Services is your content (so let’s
          refer to it as “Your Content” from this point on). We don’t make any
          claim(s) to it. That includes anything you post using our Services
          (like your images, shop name, your customer reviews, comments, videos,
          usernames, etc.).
        </p>
        <h5>Responsibility for Your Content.</h5>
        <p>
          You understand that you are solely responsible for Your Content. You
          represent that you have all necessary rights to Your Content and that
          you’re not infringing or violating any third party’s rights by posting
          it or using it on your products sold, manufactured, or warehoused by
          TinyMerch Inc.
        </p>
        <h5>Permission to Use Your Content.</h5>
        <p>
          By using our services TinyMerch agrees that your content will remain
          yours. This means that we will never use your content without your
          expressed permission. Expressed consent is defined by TinyMerch Inc.
          as any form of written request to not use content.
        </p>
        <h5>Rights You Grant TinyMerch.</h5>
        <p>
          By approving the posting Your Content, you grant TinyMerch Inc. a
          non-exclusive, worldwide, royalty-free, irrevocable, sub-licensable,
          perpetual license to use, display, edit, modify, reproduce,
          distribute, store, and prepare derivative works of Your Content to
          provide the Services and to promote TinyMerch Inc. your TinyMerch Inc.
          store, or the Services in general, in any formats and through any
          channels, including across any TinyMerch Inc. Services or third-party
          website or advertising medium.
        </p>
        <h5>Reporting Unauthorized Content.</h5>
        <p>
          TinyMerch Inc. respects intellectual property rights and follows
          intellectual property laws. Because of our esteemed respect, we are
          committed to following appropriate legal procedures to remove
          infringing content from the Service(s).
        </p>
        <h5>Intellectual Property.</h5>
        <p>
          TinyMerch respects your work and empowers you to express your voice
          and ideas. We ask that you respect the work and creative rights of
          others. You need to either own the content you submit to TinyMerch, or
          have the express authority to use, display, and resell it. Content
          must comply with right of publicity, trademark and copyright laws, and
          all other applicable state and federal laws.
        </p>
        <h5>Trademarks and Infringement of Intellectual Property:</h5>
        <p>
          In events where we receive proper notice of intellectual property
          infringement, TinyMerch Inc. strives to respond quickly by removing,
          blocking, or disabling access to the allegedly infringing material.
          When TinyMerch Inc. removes, blocks or disables access in response to
          a notice, TinyMerch Inc. makes a reasonable attempt to contact the
          allegedly infringing party, provide information about the notice and
          removal, and, in cases of confirmed copyright infringement, provide
          information about counter notification.
        </p>
        <h5>Counter DMCA Notifications:</h5>
        <p>
          If TinyMerch Inc. receives a DMCA counter notification, the removed
          material may be replaced or access to it may be restored 10 business
          days after receipt of the counter notice, unless the copyright owner
          files an action seeking a court order against the allegedly infringing
          party and informs TinyMerch Inc. of this action. TinyMerch Inc. sends
          a copy of the counter notice to the original complaining party.
        </p>
        <h5>Repeat Infringement:</h5>
        <p>
          TinyMerch Inc. terminates account privileges of members that are
          subject to repeat notices of intellectual property infringement in
          appropriate circumstances and at TinyMerch Inc.’s discretion.
        </p>
        <h5>Copyright Responsibility.</h5>
        <p>
          You agree and attest by accepting these terms and conditions and using
          our Services that you own all rights (copyrights) for the content you
          submit, or if you are not the owner, that you have express authority
          and written permission to use the content, and that you have all of
          the rights required to display, reproduce, and sell the content. If
          content that you own and have rights to has been posted to the
          Services without your permission and you want it removed, please
          contact our customer service department directly for further
          escalation and review within 30 business days from date of first
          reporting. If Your Content infringes another person’s intellectual
          property as stated in section F, we will block it at our discretion.
        </p>
        <h5>Inappropriate, False, or Misleading Content.</h5>
        <p>
          This should be common sense, but there are certain types of content we
          don’t want submitted to TinyMerch Inc.’s Services (for legal reasons
          or otherwise). You agree that you will not post any content that is
          abusive, threatening, defamatory, obscene, vulgar, or otherwise
          offensive or in violation of any part of our Terms. You also agree not
          to post any content that is false and misleading or uses the Services
          in a manner that is fraudulent or deceptive.
        </p>
        <h5>Your Use of Our Services</h5>
        <p>
          License to Use Our Services. We grant you a limited, non-exclusive,
          non-transferable, and revocable license to use our Services,
          platforms, and integrations—subject to the Terms and the following
          restrictions in particular:
        </p>
        <h3>Don’t Use Our Services to Break the Law.</h3>
        <p>
          You agree that you will not violate any laws in connection with your
          use of the Services. This includes any local, state, federal, and
          international laws that may apply to you or TinyMerch Inc. For
          example, it’s your responsibility to obtain any permits or licenses
          that your store may require; you must not engage in fraud, theft,
          anti-competitive conduct, threatening conduct, or any other unlawful
          acts or crimes against TinyMerch Inc., another TinyMerch Inc. user, or
          a third party.
        </p>
        <h5>Don’t Try to Harm Our Systems.</h5>
        <p>
          You agree not to interfere with or try to disrupt our Services, for
          example by distributing a virus or other harmful computer code into
          our platforms, third party services, or other programs or systems our
          clients may use to promote their products. You agree that TinyMerch
          Inc. reserves the right to audit our platforms (systems) to ensure
          integrity and compliance with this agreement, at the sole discretion
          of TinyMerch Inc.
        </p>
        <h5>Follow Brand Guidelines.</h5>
        <p>
          The name “TinyMerch Inc.,” our iconography, phrases, logos, and
          designs that we use in connection with Services we provide are
          trademarks, service marks, or trade dress of TinyMerch Inc. in the US,
          European Union, and all other countries, that are used for proprietary
          purposes at our sole discretion.
        </p>
        <h5>Share Your Ideas.</h5>
        <p>
          We love your suggestions and ideas! They can help us improve your
          experience and our Services. Any unsolicited ideas or other materials
          you submit to TinyMerch Inc. (not including Your Content or products
          you sell or warehouse through our Services) are considered
          non-confidential and nonproprietary to you. You grant us a
          nonexclusive, worldwide, royalty-free, irrevocable, sub-licensable,
          perpetual license to use and publish those ideas and materials for any
          purpose, without compensation to you at any time.
        </p>
        <h5>Communication Methods.</h5>
        <p>
          TinyMerch Inc. will provide you with certain legal information in
          writing. By using our Services, you’re agreeing to our communication
          methods which describes how we provide that information to you. This
          simply means that we reserve the right to send you information
          electronically (by email, etc.) instead of mailing you paper copies
          (it’s better for the environment).
        </p>
        <h5>
          Warranties and Limitation of Liability (or the Things You Can’t Sue Us
          For) Items Your clients Purchase through our sites.
        </h5>
        <p>
          You understand that TinyMerch Inc. cannot and does not make any
          warranties about our clients' images, content, stores, or what they
          sell to their end customer that we may warehouse. Any legal claim
          related to an item your customers purchase must be brought directly
          against you as the seller of the item. You release TinyMerch Inc. from
          any claims related to items sold through our Services, including
          consideration for defective items, misrepresentations by sellers, or
          items that caused physical injury (like product liability claims) from
          warehoused goods.
        </p>
        <h5>Content You Access.</h5>
        <p>
          You may come across materials that you find offensive or inappropriate
          while using our Services. We make no representations concerning any
          content posted by users through the Services. TinyMerch Inc. is not
          responsible for the accuracy, copyright compliance, legality, or
          decency of content posted by users that you accessed through the
          Services. You release us from all liability relating to that content.
        </p>
        <h5>Policy Decisions on Content and Art.</h5>
        <p>
          Policy decisions themselves are complex in nature. We consider many
          different and often divergent factors before coming to a decision
          about what is best for our company, communities, and clients. Because
          we are a creatively neutral company, we err on the side of freedom of
          expression. We also tend to allow items that have educational,
          historical, or artistic value, but we know that even those items are
          subject to a variety of valid and sometimes conflicting
          interpretations and emotional responses. Art and history can be
          provocative, emotional, and divisive. There are some topics on which
          we may never reach a consensus as a society, and that is okay.
        </p>
        <h5>Third-Party Services.</h5>
        <p>
          Our stores on our site(s) may contain links to third-party websites or
          services that we don’t own or control (for example, links to Facebook,
          Twitter, and Pinterest). You may also need to use a third party’s
          product or service in order to use some of our Services (like a
          compatible mobile device to use our mobile apps). When you access
          these third-party services, you do so at your own risk. The third
          parties may require you to accept their own terms of use. TinyMerch
          Inc. is not a party to those agreements; they are solely between you
          and the third party. Warranties. TinyMerch Inc. is dedicated to making
          our Services the best they can be, but we’re not perfect and sometimes
          things can go wrong. You understand that our Services are provided “as
          is” and without any kind of warranty (express or implied). We are
          expressly disclaiming any warranties of title, non-infringement,
          merchantability, and fitness for a particular purpose, as well as any
          warranties implied by a course of performance, course of dealing, or
          usage of trade.
        </p>
        <h5>We do not guarantee that:</h5>
        <p>
          The Services will be secure or available at any particular time or
          location; any defects or errors will be corrected; the Services will
          always be free of viruses or other harmful materials; or the results
          of using the Services will meet your expectations. You use the
          Services solely at your own risk. Some jurisdictions do not allow
          limitations on implied warranties, so the above limitations may not
          apply to you Liability Limits. To the fullest extent permitted by law,
          neither TinyMerch Inc., nor our employees or directors shall be liable
          to you for any lost profits or revenues, or for any consequential,
          incidental, indirect, special, or punitive damages arising out of or
          in connection with the Services or these Terms. In no event shall
          TinyMerch Inc.’s aggregate liability for any damages exceed the
          greater of one hundred ($100) US Dollars or the amount you paid
          TinyMerch Inc. in the past twelve months, whichever is least. Some
          jurisdictions do not allow limitations on incidental or consequential
          damages, so the above limitations may not apply to you.
        </p>
        <h5>Indemnification (or What Happens If You Get Us Sued)</h5>
        <p>
          We hope this never happens, but in the instance TinyMerch Inc. should
          get sued because of something that you did, you agree to defend and
          indemnify us. That means you’ll defend TinyMerch Inc. (including any
          of our employees) and hold us harmless from any legal claim or demand
          (including reasonable attorney’s fees) that arises from your actions,
          your use (or misuse) of our Services, your breach of the Terms, or
          your account’s infringement of someone else’s rights. <br />
          <br />We reserve the right to handle our legal defense however we see
          fit, even if you are indemnifying us, in which case you agree to
          cooperate with us so we can execute our strategy.
        </p>
        <h5>Disputes with TinyMerch Inc.</h5>
        <p>
          If you’re upset with us, let us know right away, and hopefully we can
          resolve your issue. But if we can’t, then these rules will govern any
          legal dispute involving our Services:
        </p>
        <h5>Governing Law.</h5>
        <p>
          The Terms are governed by the laws of the State in which TinyMerch
          resides as an organizational facility, without regard to its conflict
          of laws rules, and the laws of the United States of America. These
          laws will apply no matter where in the world you live, but if you live
          outside of the United States, you may be entitled to the protection of
          the mandatory consumer protection provisions of your local consumer
          protection law.
        </p>
        <h5>Arbitration.</h5>
        <p>
          You and TinyMerch Inc. agree that any dispute or claim arising from or
          relating to the Terms shall be finally settled by final and binding
          arbitration, using the English language, administered by the American
          Arbitration Association (the “AAA”) under its Commercial Arbitration
          Rule in effect at that time (those rules are deemed to be incorporated
          by reference into this section, and as of the date of these Terms you
          can find them here or by calling the AAA at 1–800–778–7879).
          Arbitration will be handled by a sole arbitrator in accordance with
          those rules. Judgment on the arbitration award may be entered in any
          court that has jurisdiction. Any arbitration under the Terms will take
          place on an individual basis—class arbitrations and class actions are
          not permitted. You understand that by agreeing to the Terms, you and
          TinyMerch Inc. are each waiving the right to trial by jury or to
          participate in a class action or class arbitration. Notwithstanding
          the foregoing, each party shall have the right to bring an action in a
          court of proper jurisdiction for injunctive or other equitable or
          conservatory relief, pending a final decision by the arbitrator. You
          may instead assert your claim in “small claims” court, but only if
          your claim qualifies, your claim remains in such court, and your claim
          remains on an individual, non-representative, and non-class basis.
        </p>
        <h5>Costs of Arbitration.</h5>
        <p>
          Payment for any and all reasonable AAA filing, administrative, and
          arbitrator fees will be in accordance with the Consumer Arbitration
          Rules. If the value of your claim does not exceed $10,000, TinyMerch
          Inc. will pay for the reasonable filing, administrative, and
          arbitrator fees associated with the arbitration, unless the arbitrator
          finds that either the substance of your claim or the relief sought was
          frivolous or brought for an improper purpose.
        </p>
        <h5>Forum.</h5>
        <p>
          We’re based in multiple states so any legal action against TinyMerch
          Inc. related to our Services must be filed and take place in the state
          of choice solely reserved by TinyMerch Inc. That means the seat of any
          arbitration shall be in any state TinyMerch chooses. For any actions
          not subject to arbitration, you (where your contract is with TinyMerch
          Inc.) and TinyMerch Inc. agree to submit to the personal jurisdiction
          of a state court located in Greenville County, SC.
        </p>
        <h5>Changes to the Terms and Conditions of Content</h5>
        <p>
          We may update these Terms from time to time. Your use of the Services
          following the changes constitutes your acceptance of the updated
          Terms.
        </p>
        <h5>Some Finer Legal Points</h5>
        <p>
          The Terms and Conditions for content, including all of the guidelines
          and policy that make up the Terms in totality, supersede any other
          agreement between you and TinyMerch Inc. regarding the Services. If
          any part of the Terms is found to be unenforceable, that part will be
          limited to the minimum extent necessary so that the Terms will
          otherwise remain in full force and effect. Our failure to enforce any
          part of the Terms is not a waiver of our right to later enforce that
          or any other part of the Terms. We may assign any of our rights and
          obligations under the Terms.
        </p>
        <h3>Responsibility of site members and visitors</h3>
        <p>
          Violation of any of this Agreement or other rules will result in the
          termination of your TinyMerch account. <br />
          <br />TinyMerch and its designees shall have the right (but not the
          obligation) in their sole discretion to pre-screen, refuse, or remove
          any Content that is available via the TinyMerch Services. <br />
          <br />TinyMerch shall have the right to remove any Content. You agree
          that you must evaluate, and bear all risks associated with, the use of
          any Content, including any reliance on the accuracy, completeness, or
          usefulness of such Content. In this regard, you acknowledge that you
          may not rely on any Content created by TinyMerch or submitted to
          TinyMerch, including without limitation information in TinyMerch
          collaborations, posts and in all other parts of the TinyMerch
          Services. Without limiting other remedies, we may limit, suspend or
          terminate our Service and User accounts, prohibit access to our Site,
          delay or remove hosted Content, and take technical and legal steps to
          keep Users off the Site if we think that they are creating problems,
          possible legal liabilities, or acting inconsistently with the letter
          or spirit of our policies. We also reserve the right to cancel
          unconfirmed accounts or accounts that have been inactive for extended
          periods of time. The User is responsible for providing TinyMerch with
          accurate information (including but not limited to its retail price).
          If the User has provided TinyMerch with inaccurate or false
          information, (a) the User shall be liable to TinyMerch for damages and
          losses (including but not limited to taxes) arising out of such
          inaccurate or false information and (b) the User shall reimburse such
          damages and losses (including but not limited to taxes) to TinyMerch,
          and (c) TinyMerch shall have the right to charge the Client for such
          damages and losses (including but not limited to taxes).
        </p>
        <h3>Payments and fees</h3>
        <p>
          TinyMerch may choose to change the fees for our Services.
          <br />
          <br /> By placing an order through the Site, you are confirming that
          you are legally entitled to use the means of payment tendered and, in
          the case of card payments, that you are either the cardholder or have
          the cardholder's express permission to utilise the card to effect
          payment. <br />
          <br />In case of an unfounded chargeback, the User shall reimburse
          TinyMerch for its losses, which consist of fulfillment costs and
          chargeback handling fees ($15 USD per chargeback). <br />
          <br /> We may refuse to process a transaction for any reason or refuse
          Service to anyone at any time at our sole discretion. We will not be
          liable to you or any third party by reason of refusing or suspending
          any transaction after processing has begun. <br />
          <br /> Unless otherwise stated, all fees and payments are quoted in
          U.S. Dollars. The User is responsible for paying all fees, payments
          and applicable taxes associated with our Site and Services. After
          receiving your order you will receive an e-mail from us confirming the
          details, description and price for the Products ordered together with
          some information on your rights to return your goods. Payment of the
          total price plus taxes and delivery must be made in full before
          dispatch of your Products. <br />
          <br /> Payouts to a Member's bank account or debit card may incur a
          $.25 transaction fee.
        </p>
        <h3>Shipping and returns</h3>
        <p>
          Once you have clicked on the "purchase" button, it might be not
          possible to edit or cancel your order. If you want to change some
          parameters, Customer addresses, etc., please contact us. We are not
          bound to make such modifications in your order, but we will do our
          best on a case-by-case basis. Replacement of Products are subject to
          TinyMerch investigation and discretion.<br />
          <br /> The risk of loss and title for such items pass to the User upon
          our delivery to the carrier. It is the Customer's responsibility to
          file any claim with a carrier for a lost shipment if carrier tracking
          indicates that the Product was delivered. In such case TinyMerch will
          not make any refunds and will not resend the Product. <br />
        </p>
        <h3>Description of products</h3>
        <p>
          Whilst many component parts of our Products are standard, all Products
          available for purchase are described on their specific design page on
          our Site. We always try to represent each design as accurately as
          possible. <br />
          <br />We use our best efforts to provide you with the best images and
          descriptions, but unfortunately cannot guarantee that colours and
          details in website images are 100% accurate representations of the
          product, and sizes might in some cases be approximate. <br />
        </p>
        <h3>Delivery</h3>
        <p>
          We only deliver to the US and Canada. User shall cover delivery costs.
          Delivery prices are additional to the Product’s price and may vary
          depending on delivery location and/or sort of Products, and additional
          charges may be added to the order for remote or difficult to access
          locations that require special attention. Flat rate delivery charges
          are shown on our checkout page; however we reserve the right to advise
          you of any additional delivery charges that apply to your specific
          delivery address. <br />
          <br />Some sort of Products are packaged and shipped separately. We
          can not guarantee delivery dates and accept no responsibility, apart
          from advising you of any known delay, for Products that are delivered
          after the estimated delivery date. Flat rate delivery times are shown
          on the Site. It is only an average estimation, and some delivery can
          take longer, or alternatively be delivered much faster. All delivery
          estimates given at the time of placing and confirming order are
          subject to change. In any case, we will do our best to contact you and
          advise you of all changes. We try our best to make delivery of Product
          as simple as possible. <br />
          <br />Ownership of the Products will only pass to you/Customer when we
          receive full payment of all sums due in respect of the Products,
          including delivery charges and taxes.
        </p>
        <h3>Release</h3>
        <p>
          You release us (and our officers, directors, agents, subsidiaries,
          joint ventures and employees) from claims, demands and damages (actual
          and consequential) of every kind and nature, known and unknown,
          arising out of or in any way connected with such disputes. You agree
          that TinyMerch has no control over and does not guarantee the delivery
          of the advertised collaborations and that TinyMerch shall be released
          from any and all damages resulting from the failure to receive any
          benefits of an anticipated collaboration.
        </p>
        <h3>Trade marks</h3>
        <p>
          If you use any of our trade marks in reference to our Products or
          Services, you must include a statement attributing that trade mark to
          us. You must not use any of our trade marks in or as the whole or part
          of your own trade marks; in connection with activities, Products or
          Services which are not ours; in a manner which may be confusing,
          misleading or deceptive; or in a manner that disparages us or our
          information, products or services (including the Site).
        </p>
        <h3>Indemnity</h3>
        <p>
          If a dispute arises between you and TinyMerch, we strongly encourage
          you to first contact us directly to seek a resolution. We will
          consider reasonable requests to resolve the dispute through
          alternative dispute resolution procedures, such as mediation or
          arbitration, as alternatives to litigation. <br />
          <br />Contracts for the purchase of Products through our Site and any
          dispute or claim arising out of or in connection with them or their
          subject matter or formation (including non-contractual disputes or
          claims) must be resolved by a court located in the State of
          California. Any dispute or claim arising out of or in connection with
          Agreement or its formation (including non-contractual disputes or
          claims) will be subject to the non-exclusive jurisdiction of the
          courts of the State of California.
        </p>
        <h3>Law and Jurisdiction</h3>
        <p>
          If you use any of our trade marks in reference to our Products or
          Services, you must include a statement attributing that trade mark to
          us. You must not use any of our trade marks in or as the whole or part
          of your own trade marks; in connection with activities, Products or
          Services which are not ours; in a manner which may be confusing,
          misleading or deceptive; or in a manner that disparages us or our
          information, products or services (including the Site).
        </p>
        <h3>General</h3>
        <p>
          No agency, partnership, joint venture, employee-employer,
          franchiser-franchisee relationship, etc. is intended or created by
          this Agreement. <br />
          <br />You acknowledge that you have all necessary permits to grant us
          with Customer’s personal data to fulfill this Agreement. <br />
          <br />If any provision of this Agreement is held to be invalid or
          unenforceable, such provision shall be struck and the remaining
          provisions shall be enforced. In our sole discretion, we may assign
          this Agreement upon notice to you. Headings are for reference purposes
          only and do not limit the scope or extent of such section. Our failure
          to act with respect to a breach by you or others does not waive our
          right to act with respect to subsequent or similar breaches. We do not
          guarantee we will take action against all breaches of this Agreement.
          <br />
          <br />TinyMerch reserves the right to transfer or assign this
          Agreement or any right or obligation under this Agreement at any time.
        </p>
        <br />
        <br />
        <p>✌️ The TinyMerch Team</p>
      </TermsPostPreview>
      <TermsPostPreview>
        <h1>Privacy Policy</h1>
        <p>
          It is our policy to respect your privacy regarding any information we
          may collect while operating our website.
        </p>
        <h3>Personal information</h3>
        <p>
          Before using certain parts of any tinymerch.com ("TinyMerch") or
          ordering Products, you must complete an online registration form.
          During registration, you will be prompted to provide to us certain
          personal information, including but not limited to User’s
          (your/company) name and email address. In addition, we may also ask
          you for your/Customer’s country of residence and/or organization’s
          country of operation, so we can comply with applicable laws and
          regulations. These kinds of personal information are used for billing
          purposes, to fulfill orders, to communicate about order and TinyMerch,
          and for internal marketing purposes. If we encounter a problem when
          processing the order, your personal information may be used to contact
          you. By registering at TinyMerch, you agree that all information
          provided in the registration data is true and accurate and that you
          will maintain and update this information as required in order to keep
          it current, complete, and accurate. TinyMerch may collect statistics
          about the behavior of visitors to its Site. TinyMerch may display this
          information publicly or provide it to others. However, TinyMerch does
          not disclose personal information other than as described here. If you
          are a registered user of a TinyMerch Site and have supplied your email
          address, TinyMerch may occasionally send you an email to tell you
          about new features, new Products, solicit your feedback. TinyMerch
          takes all measures reasonably necessary to protect against the
          unauthorized access, use, alteration or destruction personal
          information.{" "}
        </p>
        <h3>Disclosure of information</h3>
        <p>
          {" "}
          TinyMerch discloses personal information only to those of its
          employees, contractors and affiliated organizations that need to know
          that information in order to process it on TinyMerch’s behalf or to
          provide Services available at TinyMerch Site, and that have agreed not
          to disclose it to others. Some of those employees, contractors and
          affiliated organizations may be located outside of your home country.
          TinyMerch will not rent or sell personal information to anyone. Other
          than to its employees, contractors and affiliated organizations, as
          described here, TinyMerch discloses personal information only in
          response to court order or other governmental request, or when
          TinyMerch believes in good faith that disclosure is reasonably
          necessary to protect the property or rights of TinyMerch, third
          parties or the public at large.{" "}
        </p>
        <h3>Security</h3>
        <p>
          {" "}
          Your account is protected by a password for your privacy and security.
          You need to prevent unauthorized access to your account and personal
          information by selecting and protecting your password appropriately
          and limiting access to your computer and browser by signing off after
          you have finished accessing your account.{" "}
        </p>
        <h3>Cookies</h3>
        <p>
          {" "}
          TinyMerch employs cookies. Cookies are alphanumeric identifiers that
          we transfer to your computer’s hard drive through your web browser to
          enable our systems to recognize your browser. Most internet browsers
          are initially set to accept cookies. You can set your browser to
          refuse cookies from web sites or to remove cookies from your hard
          drive, but if you do, you will not be able to access or use portions
          of TinyMerch Service. We have to use cookies to enable you to select
          Products, place them in an online shopping cart, and to purchase those
          Products. If you do this, we keep a record of your browsing activity
          and purchase.{" "}
        </p>
        <h3>Business</h3>
        <p>
          If TinyMerch, or substantially all of its assets were acquired, or in
          the event that TinyMerch goes out of business or enters bankruptcy,
          your personal information would be one of the assets that is
          transferred or acquired by a third party. You acknowledge that such
          transfers may occur, and that any acquirer of TinyMerch and/or the
          Site may continue to use your personal information as set forth in
          this policy.{" "}
        </p>
        <h3>Privacy policy changes</h3>
        <p>
          TinyMerch may change its Privacy Policy from time to time, and in
          TinyMerch's sole discretion. TinyMerch encourages you to frequently
          check this page for any changes to its Privacy Policy. Your continued
          use of this Site after any change in this Privacy Policy will
          constitute your acceptance of such change.
        </p>
      </TermsPostPreview>
    </TermsWrapper>
  )
}



// WEBPACK FOOTER //
// ./src/pages/terms.js